import { cffeApi, fkcApi } from '@/api';

export const PERMISSIONS = () =>
  [
    '/selfRace/updateApplicantDetail',
    fkcApi.editAdminStuInfo.$pureUrl, // 知识比拼管理员 初赛信息编辑权限
    cffeApi.editAdminStuInfo.$pureUrl,
    cffeApi.editTeamStuInfo.$pureUrl,
    /**渠道监控-非实时初始化渠道*/
    '/channel/initChannel',
    /**实时初始化渠道（测试用）*/
    '/channel/initChannelRealtime',
    /** 金融挑战赛-管理员菜单-热身赛-编辑 */
    '/finContest/modifyStudentInfo',
    /** 金融挑战赛-领队菜单-热身赛查询-编辑 */
    '/finContest/modifyLeaderWarmInfo',
  ] as const;
